import BookInfoDialog from './BookInfoDialog';

export default BookInfoDialog;
